<div class="header">
  <span class="heading">Interaction {{ interactionDetails?.InteractionID }}</span>
  <span class="close" (click)="closeModal()">X</span>
</div>

<div class="row audit-container">
  <div class="col-6 left-col border-right">
    <div class="accordion" id="accordion-left">
      <accordion [closeOthers]="false">
        <accordion-group [isOpen]="true" (click)="recordingStatus = !recordingStatus">
          <button class="btn btn-block d-flex w-100 collapse-btn" accordion-heading type="button">
            <div class="btn-name">
              <span class="arrow">
                <img
                  class="collapse-expang-img"
                  src="{{ baseHref }}/assets/images/icon-collapse-ar.png"
                  *ngIf="!recordingStatus"
                />

                <img
                  class="collapse-expang-img"
                  src="{{ baseHref }}/assets/images/icon-expand-ar.png"
                  *ngIf="recordingStatus"
                />
              </span>
              <span class="item">RECORDING </span>
            </div>
          </button>

          <div class="audio-container">
            <div class="audio">
              <span class="audio-header"> Audio </span>
              <div class="hr-line"></div>

              <label class="recording-label" for="page">Recording</label>
              <select name="page" class="recording-page" [(ngModel)]="recordingPageNo">
                <option value="1">1</option>
                <option value="2">2</option>
              </select>
              <label class="recording-page" for="page">of 2</label>

              <app-audio></app-audio>
            </div>
          </div>
        </accordion-group>

        <accordion-group [isOpen]="false" (click)="interactionDetailStatus = !interactionDetailStatus">
          <button class="btn btn-block d-flex w-100 collapse-btn" accordion-heading type="button">
            <div class="btn-name">
              <span class="arrow">
                <img
                  class="collapse-expang-img"
                  src="{{ baseHref }}/assets/images/icon-collapse-ar.png"
                  *ngIf="!interactionDetailStatus"
                />

                <img
                  class="collapse-expang-img"
                  src="{{ baseHref }}/assets/images/icon-expand-ar.png"
                  *ngIf="interactionDetailStatus"
                />
              </span>
              <span class="item">INTERACTION DETAILS </span>
            </div>
          </button>

          <div class="interaction-detail-container">
            <div class="container">
              <div class="row user-row">
                <div class="col-6 field">Interaction ID</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.InteractionID }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Interaction Type</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.InteractionType }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Queue</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.Queue }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Disposition</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.Disposition }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Disposition Type</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.DispositionType }}
                </div>
              </div>

              <div class="row user-row">
                <div class="col-6 field">Request Type</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.RequestType }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Agent</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.Agent }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Group</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.Group }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Manager</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.Manager }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">User ID</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.UserID }}
                </div>
              </div>

              <div class="row user-row">
                <div class="col-6 field">CRM User ID</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.CrmUserID }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">User Name</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.User }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">User ID</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.UserID }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">User Phone Number</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.PhoneNumber }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Call Started</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.Started }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Queued</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.Queued }}
                </div>
              </div>

              <div class="row user-row">
                <div class="col-6 field">Answered</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.Answered }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Call Ended</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.Ended }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Follow-Up Type</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.FollowUpType }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Follow-Up Date</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.FollowUpDate }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Comments</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.Comments }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Dialer Bypassed</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.DialerBypassed }}
                </div>
              </div>

              <div class="row user-row">
                <div class="col-6 field">Bypass Explanation</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.BypassExplanation }}
                </div>
              </div>

              <div class="row user-row">
                <div class="col-6 field">Handling Time</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.HandlingTime }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Total Hold Time</div>
                <div class="col-6 field-val">
                  {{ interactionDetails?.TotalHoldTime }}
                </div>
              </div>
            </div>
          </div>
        </accordion-group>

        <accordion-group [isOpen]="false" (click)="userInformationStatus = !userInformationStatus">
          <button class="btn btn-block d-flex w-100 collapse-btn" accordion-heading type="button">
            <div class="btn-name">
              <span class="arrow">
                <img
                  class="collapse-expang-img"
                  src="{{ baseHref }}/assets/images/icon-collapse-ar.png"
                  *ngIf="!userInformationStatus"
                />

                <img
                  class="collapse-expang-img"
                  src="{{ baseHref }}/assets/images/icon-expand-ar.png"
                  *ngIf="userInformationStatus"
                />
              </span>
              <span class="item">USER INFORMATION </span>
            </div>
          </button>

          <div class="user-information-container">
            <div class="container">
              <div class="row user-row">
                <div class="col-6 field">CrmUserID</div>
                <div class="col-6 field-val">{{ userData.CrmUserID }}</div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">FirstName</div>
                <div class="col-6 field-val">{{ userData.FirstName }}-</div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">LastName</div>
                <div class="col-6 field-val">{{ userData.LastName }}</div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Email</div>
                <div class="col-6 field-val">{{ userData.Email }}</div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Designation</div>
                <div class="col-6 field-val">{{ userData.Designation }}</div>
              </div>

              <div class="row user-row">
                <div class="col-6 field">GradeBand</div>
                <div class="col-6 field-val">{{ userData.GradeBand }}</div>
              </div>

              <div class="row user-row">
                <div class="col-6 field">Country</div>
                <div class="col-6 field-val">{{ userData.Country }}</div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">State</div>
                <div class="col-6 field-val">{{ userData.State }}</div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">City</div>
                <div class="col-6 field-val">{{ userData.City }}</div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">Department or Divison</div>
                <div class="col-6 field-val">
                  {{ userData['Department or Divison'] }}
                </div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">UserID</div>
                <div class="col-6 field-val">{{ userData.UserID }}</div>
              </div>
              <div class="row user-row">
                <div class="col-6 field">PhoneNumbers</div>
                <div class="col-6 field-val">{{ userData.PhoneNumbers }}</div>
              </div>
            </div>
          </div>
        </accordion-group>
      </accordion>
    </div>
  </div>
  <div class="col-6 right-col">
    <div class="accordion" id="accordion-left">
      <accordion [closeOthers]="false">
        <accordion-group [isOpen]="true" (click)="auditStatus = !auditStatus">
          <button class="btn btn-block d-flex w-100 collapse-btn" accordion-heading type="button">
            <div class="btn-name">
              <span class="arrow">
                <img
                  class="collapse-expang-img"
                  src="{{ baseHref }}/assets/images/icon-collapse-ar.png"
                  *ngIf="!auditStatus"
                />

                <img
                  class="collapse-expang-img"
                  src="{{ baseHref }}/assets/images/icon-expand-ar.png"
                  *ngIf="auditStatus"
                />
              </span>
              <span class="item">AUDITS </span>
            </div>
          </button>

          <div class="audits-container">
            <div class="container">
              <div class="row audit-row">
                <label class="audit-label" for="page">Forms:</label>

                <select name="page" class="audit-dropdown" [(ngModel)]="selectedForm" (change)="changeFormField()">
                  <ng-container *ngFor="let item of surveyDetails">
                    <option [ngValue]="item">{{ item.Name }}</option>
                  </ng-container>
                </select>

                <!--<div class="col-3"></div>-->
              </div>
              <div class="row audit-row">
                <label class="audit-label" for="page">Types:</label>
                <select name="page" class="audit-dropdown" [(ngModel)]="selectedType" (change)="changeTypeField()">
                  <ng-container *ngFor="let type of selectedForm.Types">
                    <option [ngValue]="type">{{ type.Name }}</option>
                  </ng-container>
                </select>

                <button type="button" class="btn btn-labeled btn-default new-btn">
                  <span class="btn-label new-btn-icon"><i class="new-btn-icon"></i></span
                  ><span class="button-label">New</span>
                </button>
              </div>
              <div class="row audit-row">
                <label class="audit-label" for="page">Surveys:</label>
                <select name="page" class="audit-dropdown">
                  <option value="1">E3S_SERVICE_DESK</option>
                  <option value="2">E3S_SERVICE_DESK1</option>
                </select>

                <button type="button" class="btn btn-labeled btn-default open-btn">
                  <span class="btn-label"><i class="open-btn-icon"></i></span><span class="button-label">Open</span>
                </button>
              </div>
            </div>
          </div>
        </accordion-group>

        <accordion-group [isOpen]="false" (click)="serviceDeskStatus = !serviceDeskStatus">
          <button class="btn btn-block d-flex w-100 collapse-btn" accordion-heading type="button">
            <div class="btn-name">
              <span class="arrow">
                <img
                  class="collapse-expang-img"
                  src="{{ baseHref }}/assets/images/icon-collapse-ar.png"
                  *ngIf="!serviceDeskStatus"
                />

                <img
                  class="collapse-expang-img"
                  src="{{ baseHref }}/assets/images/icon-expand-ar.png"
                  *ngIf="serviceDeskStatus"
                />
              </span>
              <span class="item">E3S_SERVICE_DESK </span>
            </div>
            <div class="st">
              <span class="status">Submitted</span>
              <span class="rating-percentage">
                <span class="rating">(29/33)</span>
                <span class="percentage">87.9%</span>
              </span>
            </div>
          </button>

          <accordion>
            <accordion-group [isOpen]="false" (click)="callOpeningStatus = !callOpeningStatus" class="row">
              <button class="btn btn-block d-flex w-100 collapse-btn" accordion-heading type="button">
                <div class="btn-name">
                  <span class="arrow">
                    <img
                      alt=""
                      class="collapse-expang-img"
                      src="{{ baseHref }}/assets/images/icon-collapse-ar.png"
                      *ngIf="!callOpeningStatus"
                    />

                    <img
                      alt=""
                      class="collapse-expang-img"
                      src="{{ baseHref }}/assets/images/icon-expand-ar.png"
                      *ngIf="callOpeningStatus"
                    />
                  </span>
                  <span class="item">Call Opening </span>
                </div>
                <div class="st">
                  <span class="status">Completed</span>
                  <span class="rating-percentage">
                    <span class="rating">(5/5)</span>
                    <span class="percentage">100%</span>
                  </span>
                </div>
              </button>
              <div class="call-opening-content">
                <div class="row">
                  <div class="col-9">
                    <span class="call-open-label">*Greeted caller within 5 seconds of hearing tone </span>
                    <div>
                      <select class="call-open-dropdown">
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-3 star-comment">
                    <span class="star"
                      ><img alt="" class="star-img" src="{{ baseHref }}/assets/images/icon-star.png" /><span
                        class="star-text"
                        >+2</span
                      ></span
                    >
                    <span class="comment"
                      ><img alt="" class="comment-img" src="{{ baseHref }}/assets/images/icon-comment.png" /><span
                        class="comment-text"
                        >0</span
                      ></span
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-9">
                    <span class="call-open-label">*Appropriate opening greeting used </span>
                    <div>
                      <select class="call-open-dropdown">
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-3 star-comment">
                    <span class="star"
                      ><img alt="" class="star-img" src="{{ baseHref }}/assets/images/icon-star.png" /><span
                        class="star-text"
                        >+3</span
                      ></span
                    >
                    <span class="comment"
                      ><img alt="" class="comment-img" src="{{ baseHref }}/assets/images/icon-comment.png" /><span
                        class="comment-text"
                        >0</span
                      ></span
                    >
                  </div>
                </div>
              </div>
            </accordion-group>
          </accordion>

          <!--<div class="tbodyDiv">-->
          <accordion>
            <accordion-group [isOpen]="false" (click)="callHandlingStatus = !callHandlingStatus">
              <button class="btn btn-block d-flex w-100 collapse-btn" accordion-heading type="button">
                <div class="btn-name">
                  <span class="arrow">
                    <img
                      alt=""
                      class="collapse-expang-img"
                      src="{{ baseHref }}/assets/images/icon-collapse-ar.png"
                      *ngIf="!callHandlingStatus"
                    />

                    <img
                      alt=""
                      class="collapse-expang-img"
                      src="{{ baseHref }}/assets/images/icon-expand-ar.png"
                      *ngIf="callHandlingStatus"
                    />
                  </span>
                  <span class="item">Call Handling </span>
                </div>
                <div class="st">
                  <span class="status">Completed</span>
                  <span class="rating-percentage">
                    <span class="rating">(5/5)</span>
                    <span class="percentage">100%</span>
                  </span>
                </div>
              </button>

              <div class="call-handling-content">
                <div class="row">
                  <div class="col-9">
                    <span class="call-open-label">*Actively listened to caller and asked probing questions </span>
                    <div>
                      <select class="call-open-dropdown">
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-3 star-comment">
                    <span class="star"
                      ><img alt="" class="star-img" src="{{ baseHref }}/assets/images/icon-star.png" /><span
                        class="star-text"
                        >+2</span
                      ></span
                    >
                    <span class="comment"
                      ><img alt="" class="comment-img" src="{{ baseHref }}/assets/images/icon-comment.png" /><span
                        class="comment-text"
                        >0</span
                      ></span
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-9">
                    <span class="call-open-label">*Followed the appropriate transfer procedure </span>
                    <div>
                      <select class="call-open-dropdown">
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-3 star-comment">
                    <span class="star"
                      ><img alt="" class="star-img" src="{{ baseHref }}/assets/images/icon-star.png" /><span
                        class="star-text"
                        >+3</span
                      ></span
                    >
                    <span class="comment"
                      ><img alt="" class="comment-img" src="{{ baseHref }}/assets/images/icon-comment.png" /><span
                        class="comment-text"
                        >0</span
                      ></span
                    >
                  </div>
                </div>
              </div>
            </accordion-group>
          </accordion>
          <!-- </div>-->

          <!--<div class="tbodyDiv">-->
          <accordion>
            <accordion-group [isOpen]="false" (click)="effectiveCommunicationStatus = !effectiveCommunicationStatus">
              <button class="btn btn-block d-flex w-100 collapse-btn" accordion-heading type="button">
                <div class="btn-name">
                  <span class="arrow">
                    <img
                      alt=""
                      class="collapse-expang-img"
                      src="{{ baseHref }}/assets/images/icon-collapse-ar.png"
                      *ngIf="!effectiveCommunicationStatus"
                    />

                    <img
                      alt=""
                      class="collapse-expang-img"
                      src="{{ baseHref }}/assets/images/icon-expand-ar.png"
                      *ngIf="effectiveCommunicationStatus"
                    />
                  </span>
                  <span class="item">Effective Communication </span>
                </div>
                <div class="st">
                  <span class="status">Completed</span>
                  <span class="rating-percentage">
                    <span class="rating">(5/5)</span>
                    <span class="percentage">100%</span>
                  </span>
                </div>
              </button>

              <div class="effective-communication-content">
                <div class="row">
                  <div class="col-9">
                    <span class="call-open-label">*Provided accurate information </span>
                    <div>
                      <select class="call-open-dropdown">
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-3 star-comment">
                    <span class="star"
                      ><img alt="" class="star-img" src="{{ baseHref }}/assets/images/icon-star.png" /><span
                        class="star-text"
                        >+2</span
                      ></span
                    >
                    <span class="comment"
                      ><img alt="" class="comment-img" src="{{ baseHref }}/assets/images/icon-comment.png" /><span
                        class="comment-text"
                        >0</span
                      ></span
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-9">
                    <span class="call-open-label">*Listened to caller without interruptions </span>
                    <div>
                      <select class="call-open-dropdown">
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-3 star-comment">
                    <span class="star"
                      ><img alt="" class="star-img" src="{{ baseHref }}/assets/images/icon-star.png" /><span
                        class="star-text"
                        >+3</span
                      ></span
                    >
                    <span class="comment"
                      ><img alt="" class="comment-img" src="{{ baseHref }}/assets/images/icon-comment.png" /><span
                        class="comment-text"
                        >0</span
                      ></span
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-9">
                    <span class="call-open-label">*Spoke with knowledge and confidence </span>
                    <div>
                      <select class="call-open-dropdown">
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-3 star-comment">
                    <span class="star"
                      ><img alt="" class="star-img" src="{{ baseHref }}/assets/images/icon-star.png" /><span
                        class="star-text"
                        >+3</span
                      ></span
                    >
                    <span class="comment"
                      ><img alt="" class="comment-img" src="{{ baseHref }}/assets/images/icon-comment.png" /><span
                        class="comment-text"
                        >0</span
                      ></span
                    >
                  </div>
                </div>
              </div>
            </accordion-group>
          </accordion>
          <!-- </div>-->

          <!--<div class="tbodyDiv">-->
          <accordion>
            <accordion-group [isOpen]="false" (click)="criticalErrorStatus = !criticalErrorStatus">
              <button class="btn btn-block d-flex w-100 collapse-btn" accordion-heading type="button">
                <div class="btn-name">
                  <span class="arrow">
                    <img
                      alt=""
                      class="collapse-expang-img"
                      src="{{ baseHref }}/assets/images/icon-collapse-ar.png"
                      *ngIf="!criticalErrorStatus"
                    />

                    <img
                      alt=""
                      class="collapse-expang-img"
                      src="{{ baseHref }}/assets/images/icon-expand-ar.png"
                      *ngIf="criticalErrorStatus"
                    />
                  </span>
                  <span class="item">Critical Errors </span>
                </div>
                <div class="st">
                  <span class="status">Completed</span>
                  <span class="rating-percentage">
                    <span class="rating">(5/5)</span>
                    <span class="percentage">100%</span>
                  </span>
                </div>
              </button>

              <div class="critical-errors-content">
                <div class="row">
                  <div class="col-9">
                    <span class="call-open-label">*Displayed professionalism during the call </span>
                    <div>
                      <select class="call-open-dropdown">
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-3 star-comment">
                    <span class="star"
                      ><img alt="" class="star-img" src="{{ baseHref }}/assets/images/icon-star.png" /><span
                        class="star-text"
                        >+2</span
                      ></span
                    >
                    <span class="comment"
                      ><img alt="" class="comment-img" src="{{ baseHref }}/assets/images/icon-comment.png" /><span
                        class="comment-text"
                        >0</span
                      ></span
                    >
                  </div>
                </div>
              </div>
            </accordion-group>
          </accordion>
          <!-- </div>-->
        </accordion-group>
      </accordion>
    </div>
  </div>
</div>
